import React from 'react';
import { CasePrintPage } from 'containers/pages/cases/components/casePrint';

export default function CasePrint() {
	return <CasePrintPage />;
}
